import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import MedCard from './MedCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faPhone, faPills } from '@fortawesome/free-solid-svg-icons';

const PatientCard = ({ patient }) => {
    const facilityList = JSON.parse(localStorage.getItem("facilitiesData"));
    const deliveryTypes = JSON.parse(localStorage.getItem("delivery_types")) || {};
    let facilityObj = facilityList.reduce((obj, item) => {
        obj[item.value] = item.key;
        return obj;
    }, {});

    const isHospice = patient?.orders?.some(order => Number(order.order_type) === 7);
    const highlight = patient.orders?.some(order => Number(order.created_by_role_id) < 4);

    const isPharmacyAttention = patient?.orders?.some(order => order.is_pharmacy_attention);
    const isCallBack = patient?.orders?.some(order => order.is_callback);

    const hasDeliveryType = (matcher) =>
        patient.orders?.some(order => matcher(Number(order.delivery_type), (deliveryTypes[order.delivery_type] || '').toLowerCase()));

    const deliveryColor = (() => {
        if (hasDeliveryType((type) => type === 1)) {
            return { header: 'bg-red text-white', body: 'bg-red-body' };
        }
        if (hasDeliveryType((type) => type === 5)) {
            return { header: 'bg-brown text-white', body: 'bg-brown-body' };
        }
        if (hasDeliveryType((type, label) => type === 2 || label.includes('morning'))) {
            return { header: 'delivery-morning-header text-dark', body: 'delivery-morning-body' };
        }
        if (hasDeliveryType((type, label) => type === 3 || label.includes('evening'))) {
            return { header: 'delivery-evening-header text-white', body: 'delivery-evening-body' };
        }
        return { header: 'delivery-other-header text-white', body: 'delivery-other-body' };
    })();

    function getEarliestDeliveryDate(patient) {
        const dates = patient.orders
            .map(order => order.delivery_date)
            .filter(Boolean)
            .map(date => moment(date))
            .filter(d => d.isValid());

        if (dates.length === 0) return null;

        const earliest = moment.min(dates);
        return earliest.format('MM/DD/YY');
    }

    return (
        <Card
            className={`cycleViewCard m-2 overflow-hidden ${highlight ? "highlight-card" : ""}`}
            role="button"
        >
            {/* {isHospice && <div className="hospice-flag">
                ⚕️ HOSPICE
            </div>} */}
            {/* <Card.Header className={
                `${isDeliveryTypeOne ? "bg-red" : isDeliveryTypeFive ? "bg-brown" : "bg-orange"} 
            px-3 py-1 text-white`
            }>
                {patient.patient_lastname},{patient?.patient_firstname}
            </Card.Header> */}

            <Card.Header
                className={`${deliveryColor.header} px-3 py-1 d-flex align-items-center justify-content-between`}>
                <span className="patient-name">
                    {patient.patient_lastname},{patient?.patient_firstname}
                </span>

                {isPharmacyAttention && (
                    <span>
                        <FontAwesomeIcon icon={faExclamationTriangle}/>
                    </span>
                )}
                 {isCallBack && (
                    <span>
                        <FontAwesomeIcon icon={faPhone}/>
                    </span>
                )}

                {isHospice && (
                    <span className="hospice-pill">
                        ⚕️ HOSPICE
                    </span>
                )}
            </Card.Header>


            {/* <Card.Body className={"bg-orange-body text-dark px-2 py-1"}> */}
            <Card.Body className={
                `${deliveryColor.body} 
   text-dark px-2 py-1`
            }>

                <Row>
                    <Col xs="7">
                        <span>{facilityObj[patient.facility_id]}</span>
                    </Col>
                    <Col xs="5" className="text-end">
                        {getEarliestDeliveryDate(patient)}
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        {patient?.orders?.map((order, i) => (
                            <div
                                key={i}
                                className={`position-relative mb-1 rounded-2 shadow-sm ${order?.is_callback ? "" : "bg-white"}`}
                                style={order?.is_callback ? { backgroundColor: "#E9EDF2" } : undefined}
                            >
                                {(order?.internal_notes?.length > 0) && (
                                    <div className="position-absolute top-0 bottom-0 start-0 bg-success"
                                        style={{ width: 6, borderTopLeftRadius: 'inherit', borderBottomLeftRadius: 'inherit' }}
                                    />
                                )}
                                {(order?.notes?.length > 0) && (
                                    <div className="position-absolute top-0 bottom-0 end-0 bg-info-dark"
                                        style={{ width: 6, borderTopRightRadius: 'inherit', borderBottomRightRadius: 'inherit' }}
                                    />
                                )}
                                <div className="px-2 py-0">
                                    <MedCard data={order} />
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default PatientCard;
